import React, { FC } from 'react';
import sampleWarehouseEmail from '../../../assets/sampleWarehouseEmail.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import {
    HelpAlert,
    HelpBody,
    HelpBullet,
    HelpImage,
    HelpIndent,
    HelpStep,
    HelpSubheading,
    HelpTitle,
} from './HelpElements';

const IneligibleReturnsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('ineligibleReturnsHelp');

    return (
        <>
            <HelpTitle>{t('ineligibleReturnsHelp_Title')}</HelpTitle>
            <HelpBody>{t('ineligibleReturnsHelp_purpose')}</HelpBody>
            <HelpIndent>
                <HelpBullet>{t('ineligibleReturnsHelp_itemsExceeded')}</HelpBullet>
                <HelpBullet>{t('ineligibleReturnsHelp_accessories')}</HelpBullet>
                <HelpBullet>{t('ineligibleReturnsHelp_demoUnits')}</HelpBullet>
                <HelpBullet>{t('ineligibleReturnsHelp_fraud')}</HelpBullet>
                <HelpBullet>{t('ineligibleReturnsHelp_emptyBox')}</HelpBullet>
                <HelpBullet>{t('ineligibleReturnsHelp_nonAmazonProduct')}</HelpBullet>
            </HelpIndent>
            <HelpSubheading>{t('ineligibleReturnsHelp_handlingOptions')}</HelpSubheading>
            <HelpBody>{t('ineligibleReturnsHelp_handlingOption1')}</HelpBody>
            <HelpBody>{t('ineligibleReturnsHelp_handlingOption2')}</HelpBody>
            <HelpSubheading>{t('ineligibleReturnsHelp_process')}</HelpSubheading>
            <HelpStep step={1}>{t('ineligibleReturnsHelp_contactUs')}</HelpStep>
            <HelpStep step={2}>{t('ineligibleReturnsHelp_warehouseCollects')}</HelpStep>
            <HelpStep step={3}>{t('ineligibleReturnsHelp_warehouseEmail')}</HelpStep>
            <HelpImage size={'large'} src={sampleWarehouseEmail} />
            <HelpAlert>{t('ineligibleReturnsHelp_resellerResponsible')}</HelpAlert>
        </>
    );
};

export { IneligibleReturnsHelp };
